module.exports = __webpack_public_path__ + "static/media/spectators-correct-answer.ae2f016b.gif";